export const WorkOrdersManagementTabsData = [
  { label: 'work-details' },
  { label: 'quotations' },
  { label: 'reference' },
  // { label: 'notes' },
  { label: 'documents' },
  { label: 'activities' },
];
